import { render, staticRenderFns } from "./SamSmallButton.vue?vue&type=template&id=7ec69046&scoped=true&"
import script from "./SamSmallButton.vue?vue&type=script&lang=js&"
export * from "./SamSmallButton.vue?vue&type=script&lang=js&"
import style0 from "./SamSmallButton.vue?vue&type=style&index=0&id=7ec69046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec69046",
  null
  
)

export default component.exports